export const generatedSidecarReadinessLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-sidecar-readiness-ledger",
  "operatingRule": "Runtime sidecar readiness is separate from science promotion: preflight readiness can schedule runs, but only validated runtime artifacts can promote model evidence.",
  "contractHash": "sha256-7c4a24f9f81457204cb8d56bf3773f1b757ad96b02af5c4cedade5f84a61a81f",
  "sidecarPromotionLedgerHash": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
  "sidecarWorkOrderPacketHash": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
  "sidecarRunSpecPacketHash": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
  "preflightReportCount": 5,
  "preflightReports": [
    {
      "path": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
      "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
      "generatedAt": "2026-07-01T09:10:46.037Z",
      "readyContractIds": [
        "openmdao-dymos-optimization-v1",
        "spice-gf-event-window-v1"
      ],
      "blockedContractIds": [
        "gmat-transfer-v1",
        "orekit-propagation-v1",
        "tudat-transfer-v1"
      ]
    },
    {
      "path": "evidence/sidecar-runtime-preflight/full-local-runtime-preflight-report.json",
      "reportHash": "sha256-a261819e4d94fb12d503914d9f8b26c5c6ad65cb80204158e089c88ea2833182",
      "generatedAt": "2026-06-20T23:59:00.000Z",
      "readyContractIds": [],
      "blockedContractIds": [
        "gmat-transfer-v1",
        "openmdao-dymos-optimization-v1",
        "orekit-propagation-v1",
        "spice-gf-event-window-v1",
        "tudat-transfer-v1"
      ]
    },
    {
      "path": "evidence/sidecar-runtime-preflight/openmdao-dymos-local-preflight-report.json",
      "reportHash": "sha256-4e04ed71b65da4e44fef0084dc844effb3ccf04dc3ea97b11bad661a96147f47",
      "generatedAt": "2026-06-20T14:08:00.000Z",
      "readyContractIds": [
        "openmdao-dymos-optimization-v1",
        "spice-gf-event-window-v1"
      ],
      "blockedContractIds": [
        "gmat-transfer-v1",
        "orekit-propagation-v1",
        "tudat-transfer-v1"
      ]
    },
    {
      "path": "evidence/sidecar-runtime-preflight/spice-gf-kernel-manifest-preflight-report.json",
      "reportHash": "sha256-8c59377d22c78ed50bc9130bcbea805101f08c8853b730de44943d1ad5069006",
      "generatedAt": "2026-06-20T06:02:00.000Z",
      "readyContractIds": [
        "spice-gf-event-window-v1"
      ],
      "blockedContractIds": [
        "gmat-transfer-v1",
        "openmdao-dymos-optimization-v1",
        "orekit-propagation-v1",
        "tudat-transfer-v1"
      ]
    },
    {
      "path": "evidence/sidecar-runtime-preflight/spiceypy-local-preflight-report.json",
      "reportHash": "sha256-c96900f5e2ee4ff270da42cb4caa58ae7e2df4113de535c5195bb077549c9a89",
      "generatedAt": "2026-06-20T15:31:00.000Z",
      "readyContractIds": [
        "openmdao-dymos-optimization-v1"
      ],
      "blockedContractIds": [
        "gmat-transfer-v1",
        "orekit-propagation-v1",
        "spice-gf-event-window-v1",
        "tudat-transfer-v1"
      ]
    }
  ],
  "contractCount": 5,
  "promotedRuntimeContractCount": 2,
  "currentReproduciblePromotedContractCount": 2,
  "promotedButNotCurrentlyReproducibleCount": 0,
  "priorReproduciblePromotedContractCount": 0,
  "environmentDriftContractCount": 0,
  "readyToRunContractCount": 0,
  "blockedRuntimeContractCount": 3,
  "stateCounts": {
    "runtime-artifact-promoted": 2,
    "blocked-runtime-prerequisites": 3
  },
  "platformRuntimeReady": false,
  "contracts": [
    {
      "contractId": "spice-gf-event-window-v1",
      "tool": "NASA NAIF SPICE Geometry Finder",
      "domain": "ephemeris-event-windows",
      "sourceIds": [
        "spice-gf"
      ],
      "readinessState": "runtime-artifact-promoted",
      "promotedArtifactId": "spice-gf-runtime-mercury-clear-link-22deg-2025",
      "promotedArtifactHash": "sha256-6bba7e3d4ceef9f865c3cf9acee8fe83bd68bf0d803fafb7b852530cffcad8f0",
      "promotedValidationHash": "sha256-b821956c87d700973de4b729e8521d88236ca7879136d54efa0e4efa32686d3c",
      "promotedReportPath": "evidence/sidecar-intake-reports/spice-gf-clear-link-22deg-2025-intake-report.json",
      "readyPreflightReportCount": 3,
      "latestPreflightCanReproduce": true,
      "bestPreflightCanReproduce": true,
      "reproducibilityState": "promoted-artifact-currently-reproducible",
      "reproducibilityBlockers": [],
      "latestPreflight": {
        "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
        "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
        "generatedAt": "2026-07-01T09:10:46.037Z",
        "preflightState": "ready-to-run-runtime-worker",
        "passedProbeIds": [
          "python-runtime",
          "spice-worker-script",
          "python-module-spiceypy",
          "spice-kernel-manifest"
        ],
        "blockedProbeIds": [],
        "setupActions": [],
        "blockers": [],
        "scaffoldReady": true
      },
      "bestActionablePreflight": {
        "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
        "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
        "generatedAt": "2026-07-01T09:10:46.037Z",
        "preflightState": "ready-to-run-runtime-worker",
        "passedProbeIds": [
          "python-runtime",
          "spice-worker-script",
          "python-module-spiceypy",
          "spice-kernel-manifest"
        ],
        "blockedProbeIds": [],
        "setupActions": [],
        "blockers": [],
        "scaffoldReady": true
      },
      "preflightAuditNote": "Latest environment probe and best actionable contract preflight are aligned.",
      "commandTemplate": "python sidecars/spice_gf/run_spice_gf.py --scenario <scenarioId> --kernel-manifest <kernelManifest.json> --constraints <constraints.json> --out artifacts/sidecars/spice-gf-event-window-v1.json",
      "requiredOutputPath": "artifacts/sidecars/spice-gf-event-window-v1.json",
      "requiredFields": [
        "toolVersion",
        "runAt",
        "scenarioId",
        "kernelSet",
        "kernelHashes",
        "timeScale",
        "gfConstraint",
        "eventWindows",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "limitations",
        "validationStatus"
      ],
      "acceptanceGates": [
        "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
        "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
        "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
        "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
        "SPICE kernel coverage, TDB/ET time key, confinement window, GF constraint, and event-window endpoints are recorded."
      ],
      "evidenceBoundary": "Readiness records are operational planning evidence only. Runtime sidecar outputs must still be generated, hashed, validated, reviewed, and promoted before science or business claims can use them.",
      "nextAction": "Review promoted runtime artifact against claim-level acceptance criteria before using it in customer deliverables.",
      "readinessHash": "sha256-a30df59ba18a6787ab37d68842db0d846b284c3c00af038b144fe3a2027ff6d3"
    },
    {
      "contractId": "orekit-propagation-v1",
      "tool": "Orekit",
      "domain": "trajectory-propagation",
      "sourceIds": [
        "orekit"
      ],
      "readinessState": "blocked-runtime-prerequisites",
      "promotedArtifactId": null,
      "promotedArtifactHash": null,
      "promotedValidationHash": null,
      "promotedReportPath": null,
      "readyPreflightReportCount": 0,
      "latestPreflightCanReproduce": false,
      "bestPreflightCanReproduce": false,
      "reproducibilityState": "no-promoted-artifact-runtime-blocked",
      "reproducibilityBlockers": [],
      "latestPreflight": {
        "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
        "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
        "generatedAt": "2026-07-01T09:10:46.037Z",
        "preflightState": "blocked-missing-input-custody",
        "passedProbeIds": [],
        "blockedProbeIds": [
          "java-runtime",
          "orekit-data-path",
          "orekit-sidecar-jar"
        ],
        "setupActions": [
          {
            "probeId": "java-runtime",
            "ok": false,
            "blockerClass": "system-runtime",
            "setupAction": "Install a reviewed Java runtime compatible with the Orekit sidecar build and record `java -version` output.",
            "verificationCommand": "java -version",
            "custodyNote": "Record Java vendor/version, Gradle build output, Orekit dependency version, sidecar jar hash, and OREKIT_DATA_PATH hash."
          },
          {
            "probeId": "orekit-data-path",
            "ok": false,
            "blockerClass": "input-custody",
            "setupAction": "Set OREKIT_DATA_PATH to a reviewed Orekit data archive or directory with time-scale, Earth orientation, and ephemeris data.",
            "verificationCommand": "test -e \"$OREKIT_DATA_PATH\"",
            "custodyNote": "Record archive/directory hash, data-source notes, coverage date, and any redistribution/license constraints."
          },
          {
            "probeId": "orekit-sidecar-jar",
            "ok": false,
            "blockerClass": "build-artifact",
            "setupAction": "Build the Orekit sidecar jar from sidecars/orekit after Java/Gradle dependencies are reviewed.",
            "verificationCommand": "test -f \"$OREKIT_SIDECAR_JAR\"",
            "custodyNote": "Record build command, source tree hash, dependency lock/version output, jar hash, and reviewer approval."
          }
        ],
        "blockers": [
          "Missing command/runtime: Java",
          "Missing path or env input: OREKIT_DATA_PATH",
          "Missing path or env input: OREKIT_SIDECAR_JAR"
        ],
        "scaffoldReady": true
      },
      "bestActionablePreflight": {
        "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
        "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
        "generatedAt": "2026-07-01T09:10:46.037Z",
        "preflightState": "blocked-missing-input-custody",
        "passedProbeIds": [],
        "blockedProbeIds": [
          "java-runtime",
          "orekit-data-path",
          "orekit-sidecar-jar"
        ],
        "setupActions": [
          {
            "probeId": "java-runtime",
            "ok": false,
            "blockerClass": "system-runtime",
            "setupAction": "Install a reviewed Java runtime compatible with the Orekit sidecar build and record `java -version` output.",
            "verificationCommand": "java -version",
            "custodyNote": "Record Java vendor/version, Gradle build output, Orekit dependency version, sidecar jar hash, and OREKIT_DATA_PATH hash."
          },
          {
            "probeId": "orekit-data-path",
            "ok": false,
            "blockerClass": "input-custody",
            "setupAction": "Set OREKIT_DATA_PATH to a reviewed Orekit data archive or directory with time-scale, Earth orientation, and ephemeris data.",
            "verificationCommand": "test -e \"$OREKIT_DATA_PATH\"",
            "custodyNote": "Record archive/directory hash, data-source notes, coverage date, and any redistribution/license constraints."
          },
          {
            "probeId": "orekit-sidecar-jar",
            "ok": false,
            "blockerClass": "build-artifact",
            "setupAction": "Build the Orekit sidecar jar from sidecars/orekit after Java/Gradle dependencies are reviewed.",
            "verificationCommand": "test -f \"$OREKIT_SIDECAR_JAR\"",
            "custodyNote": "Record build command, source tree hash, dependency lock/version output, jar hash, and reviewer approval."
          }
        ],
        "blockers": [
          "Missing command/runtime: Java",
          "Missing path or env input: OREKIT_DATA_PATH",
          "Missing path or env input: OREKIT_SIDECAR_JAR"
        ],
        "scaffoldReady": true
      },
      "preflightAuditNote": "Latest environment probe and best actionable contract preflight are aligned.",
      "commandTemplate": "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
      "requiredOutputPath": "artifacts/sidecars/orekit-propagation-v1.json",
      "requiredFields": [
        "toolVersion",
        "runAt",
        "scenarioId",
        "dataContext",
        "frames",
        "timeScale",
        "forceModel",
        "events",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison",
        "limitations",
        "validationStatus"
      ],
      "acceptanceGates": [
        "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
        "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
        "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
        "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
        "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
      ],
      "evidenceBoundary": "Readiness records are operational planning evidence only. Runtime sidecar outputs must still be generated, hashed, validated, reviewed, and promoted before science or business claims can use them.",
      "nextAction": "Resolve runtime prerequisites: Missing command/runtime: Java; Missing path or env input: OREKIT_DATA_PATH; Missing path or env input: OREKIT_SIDECAR_JAR.",
      "readinessHash": "sha256-766c85f8a86b7afda85840908f7f16dd955f47faf2f8df79420fd6ec53f1d1ff"
    },
    {
      "contractId": "gmat-transfer-v1",
      "tool": "NASA GMAT",
      "domain": "mission-design-transfer",
      "sourceIds": [
        "gmat"
      ],
      "readinessState": "blocked-runtime-prerequisites",
      "promotedArtifactId": null,
      "promotedArtifactHash": null,
      "promotedValidationHash": null,
      "promotedReportPath": null,
      "readyPreflightReportCount": 0,
      "latestPreflightCanReproduce": false,
      "bestPreflightCanReproduce": false,
      "reproducibilityState": "no-promoted-artifact-runtime-blocked",
      "reproducibilityBlockers": [],
      "latestPreflight": {
        "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
        "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
        "generatedAt": "2026-07-01T09:10:46.037Z",
        "preflightState": "blocked-missing-runtime",
        "passedProbeIds": [
          "gmat-worker-implementation"
        ],
        "blockedProbeIds": [
          "gmat-executable"
        ],
        "setupActions": [
          {
            "probeId": "gmat-executable",
            "ok": false,
            "blockerClass": "external-application",
            "setupAction": "Install NASA GMAT, set GMAT_BIN to the tested executable path, and record the executable/version evidence.",
            "verificationCommand": "$GMAT_BIN --help",
            "custodyNote": "Record GMAT version, script hash, force-model assumptions, run logs, and output manifest hash before sidecar intake."
          }
        ],
        "blockers": [
          "Missing command/runtime: GMAT"
        ],
        "scaffoldReady": true
      },
      "bestActionablePreflight": {
        "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
        "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
        "generatedAt": "2026-07-01T09:10:46.037Z",
        "preflightState": "blocked-missing-runtime",
        "passedProbeIds": [
          "gmat-worker-implementation"
        ],
        "blockedProbeIds": [
          "gmat-executable"
        ],
        "setupActions": [
          {
            "probeId": "gmat-executable",
            "ok": false,
            "blockerClass": "external-application",
            "setupAction": "Install NASA GMAT, set GMAT_BIN to the tested executable path, and record the executable/version evidence.",
            "verificationCommand": "$GMAT_BIN --help",
            "custodyNote": "Record GMAT version, script hash, force-model assumptions, run logs, and output manifest hash before sidecar intake."
          }
        ],
        "blockers": [
          "Missing command/runtime: GMAT"
        ],
        "scaffoldReady": true
      },
      "preflightAuditNote": "Latest environment probe and best actionable contract preflight are aligned.",
      "commandTemplate": "python sidecars/gmat/run_gmat_transfer.py --scenario <scenarioId> --manifest <gmat-script-manifest.json> --report <reviewed-gmat-run-report.json> --out artifacts/sidecars/gmat/gmat-transfer-v1.json",
      "requiredOutputPath": "artifacts/sidecars/gmat/gmat-transfer-v1.json",
      "requiredFields": [
        "gmatVersion",
        "runAt",
        "scenarioId",
        "scriptHash",
        "epoch",
        "forceModel",
        "optimizer",
        "trajectorySummary",
        "constraintSummary",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison",
        "limitations",
        "validationStatus"
      ],
      "acceptanceGates": [
        "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
        "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
        "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
        "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
        "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
      ],
      "evidenceBoundary": "Readiness records are operational planning evidence only. Runtime sidecar outputs must still be generated, hashed, validated, reviewed, and promoted before science or business claims can use them.",
      "nextAction": "Resolve runtime prerequisites: Missing command/runtime: GMAT.",
      "readinessHash": "sha256-408221cbd9d34c1317b3307812c441a055fd024676a92c4d421b5b82d5679baf"
    },
    {
      "contractId": "tudat-transfer-v1",
      "tool": "Tudat",
      "domain": "cross-tool-trajectory-validation",
      "sourceIds": [
        "tudat"
      ],
      "readinessState": "blocked-runtime-prerequisites",
      "promotedArtifactId": null,
      "promotedArtifactHash": null,
      "promotedValidationHash": null,
      "promotedReportPath": null,
      "readyPreflightReportCount": 0,
      "latestPreflightCanReproduce": false,
      "bestPreflightCanReproduce": false,
      "reproducibilityState": "no-promoted-artifact-runtime-blocked",
      "reproducibilityBlockers": [],
      "latestPreflight": {
        "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
        "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
        "generatedAt": "2026-07-01T09:10:46.037Z",
        "preflightState": "blocked-missing-runtime",
        "passedProbeIds": [
          "python-runtime",
          "tudat-worker-implementation"
        ],
        "blockedProbeIds": [
          "python-module-tudatpy"
        ],
        "setupActions": [
          {
            "probeId": "python-module-tudatpy",
            "ok": false,
            "blockerClass": "python-package",
            "setupAction": "Install TudatPy in a reviewed virtual environment using sidecars/tudat/requirements.txt.",
            "verificationCommand": "python -c \"import tudatpy; import importlib.metadata as m; print(m.version('tudatpy'))\"",
            "custodyNote": "Record TudatPy version, environment lock or requirements hash, body settings hash, and cross-tool comparison plan."
          }
        ],
        "blockers": [
          "Missing Python module: tudatpy"
        ],
        "scaffoldReady": true
      },
      "bestActionablePreflight": {
        "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
        "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
        "generatedAt": "2026-07-01T09:10:46.037Z",
        "preflightState": "blocked-missing-runtime",
        "passedProbeIds": [
          "python-runtime",
          "tudat-worker-implementation"
        ],
        "blockedProbeIds": [
          "python-module-tudatpy"
        ],
        "setupActions": [
          {
            "probeId": "python-module-tudatpy",
            "ok": false,
            "blockerClass": "python-package",
            "setupAction": "Install TudatPy in a reviewed virtual environment using sidecars/tudat/requirements.txt.",
            "verificationCommand": "python -c \"import tudatpy; import importlib.metadata as m; print(m.version('tudatpy'))\"",
            "custodyNote": "Record TudatPy version, environment lock or requirements hash, body settings hash, and cross-tool comparison plan."
          }
        ],
        "blockers": [
          "Missing Python module: tudatpy"
        ],
        "scaffoldReady": true
      },
      "preflightAuditNote": "Latest environment probe and best actionable contract preflight are aligned.",
      "commandTemplate": "python sidecars/tudat/run_tudat_transfer.py --scenario <scenarioId> --settings <bodySettings.json> --report <reviewed-tudat-run-report.json> --out artifacts/sidecars/tudat/tudat-transfer-v1.json",
      "requiredOutputPath": "artifacts/sidecars/tudat/tudat-transfer-v1.json",
      "requiredFields": [
        "toolVersion",
        "runAt",
        "scenarioId",
        "bodySettings",
        "integrator",
        "propagatorSettings",
        "trajectorySummary",
        "residualSummary",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison",
        "limitations",
        "validationStatus"
      ],
      "acceptanceGates": [
        "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
        "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
        "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
        "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
        "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
      ],
      "evidenceBoundary": "Readiness records are operational planning evidence only. Runtime sidecar outputs must still be generated, hashed, validated, reviewed, and promoted before science or business claims can use them.",
      "nextAction": "Resolve runtime prerequisites: Missing Python module: tudatpy.",
      "readinessHash": "sha256-88e50b4ad7e5b4bb915d0efcafffbce64a9efdfd7a78c57c1e1794833ae2a558"
    },
    {
      "contractId": "openmdao-dymos-optimization-v1",
      "tool": "OpenMDAO/Dymos",
      "domain": "optimization-and-sensitivity",
      "sourceIds": [
        "openmdao",
        "dymos"
      ],
      "readinessState": "runtime-artifact-promoted",
      "promotedArtifactId": "openmdao-dymos-runtime-moon-logistics-beta-optimization",
      "promotedArtifactHash": "sha256-4ae76fa49e39336042cd1e76f36873c538a5a60e80e5194289d5a1daf909b896",
      "promotedValidationHash": "sha256-c407d3e66feefebc869d40e3bfa3730a4fc2c7615e740449f2da4010e443ddd7",
      "promotedReportPath": "evidence/sidecar-intake-reports/openmdao-dymos-runtime-intake-report.json",
      "readyPreflightReportCount": 3,
      "latestPreflightCanReproduce": true,
      "bestPreflightCanReproduce": true,
      "reproducibilityState": "promoted-artifact-currently-reproducible",
      "reproducibilityBlockers": [],
      "latestPreflight": {
        "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
        "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
        "generatedAt": "2026-07-01T09:10:46.037Z",
        "preflightState": "ready-to-run-runtime-worker",
        "passedProbeIds": [
          "python-runtime",
          "python-module-openmdao",
          "python-module-dymos",
          "openmdao-dymos-worker-script",
          "openmdao-dymos-problem-file"
        ],
        "blockedProbeIds": [],
        "setupActions": [],
        "blockers": [],
        "scaffoldReady": true
      },
      "bestActionablePreflight": {
        "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
        "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
        "generatedAt": "2026-07-01T09:10:46.037Z",
        "preflightState": "ready-to-run-runtime-worker",
        "passedProbeIds": [
          "python-runtime",
          "python-module-openmdao",
          "python-module-dymos",
          "openmdao-dymos-worker-script",
          "openmdao-dymos-problem-file"
        ],
        "blockedProbeIds": [],
        "setupActions": [],
        "blockers": [],
        "scaffoldReady": true
      },
      "preflightAuditNote": "Latest environment probe and best actionable contract preflight are aligned.",
      "commandTemplate": "python sidecars/openmdao_dymos/run_optimization.py --problem artifacts/sidecars/openmdao_dymos/moon-logistics-beta.problem.json --out artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
      "requiredOutputPath": "artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
      "requiredFields": [
        "toolVersion",
        "runAt",
        "scenarioId",
        "problemHash",
        "transcription",
        "optimizer",
        "objective",
        "constraints",
        "sensitivitySummary",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison",
        "limitations",
        "validationStatus"
      ],
      "acceptanceGates": [
        "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
        "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
        "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
        "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
        "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
      ],
      "evidenceBoundary": "Readiness records are operational planning evidence only. Runtime sidecar outputs must still be generated, hashed, validated, reviewed, and promoted before science or business claims can use them.",
      "nextAction": "Review promoted runtime artifact against claim-level acceptance criteria before using it in customer deliverables.",
      "readinessHash": "sha256-6c97cc882c1df4c7705d2dda567cd773d0dbf2397ade5edbb0514b9aaaebb1d5"
    }
  ],
  "evidenceBoundary": "This ledger is a scheduler and governance artifact. It is not trajectory, event-window, optimization, economics, or resource evidence.",
  "ledgerHash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8"
}
;
